import { Modal, Button } from '@/components/ui'
import { SendOutlined } from '@ant-design/icons'

interface SendConfirmModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  message: string
  loading?: boolean
}

export const SendConfirmModal: React.FC<SendConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  message,
  loading = false,
}) => {
  return (
    <Modal
      title="Send Push Notification"
      open={open}
      onClose={onClose}
      footer={
        <div className="flex justify-end gap-3">
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            loading={loading}
          >
            Send Now
          </Button>
        </div>
      }
      width={480}
      centered
    >
      <div className="py-2">
        <div className="flex items-center gap-2 mb-3 text-black/85">
          <SendOutlined className="text-lg text-primary-500" />
          <span className="text-sm font-semibold">Send push notification now?</span>
        </div>
        <p className="text-sm text-black/65 mb-2">
          Confirm you would like to send the push notification for:
        </p>
        <p className="text-sm font-medium text-black/85">{message}</p>
      </div>
    </Modal>
  )
}
